import * as $ from 'jquery';

import { SendTicketsApplication } from './SendTicketsApplication';

$(() => {
    const sendTicketsPageContainer = $('[data-send-tickets-form]');

    // If we are not on send tickets page we stop script
    if (sendTicketsPageContainer.length === 0) {
        return;
    }

    let container = $(sendTicketsPageContainer[0]);
    container.data('sendticketsApp', new SendTicketsApplication(container));
});
